export type DocumentSource =
  | 'shared-with'
  | 'shared-by'
  | 'report'
  | 'export'
  | 'internal';

export const SOURCE_BADGE_CONFIG: Record<
  DocumentSource,
  { label: string; className: string }
> = {
  'shared-with': {
    label: 'Praetorian',
    className: 'bg-chariot-brand-tertiary text-chariot-brand-primary',
  },
  'shared-by': {
    label: 'Customer',
    className: 'bg-orange-500/10 text-orange-400',
  },
  report: {
    label: 'Report',
    className: 'bg-green-500/10 text-green-400',
  },
  export: {
    label: 'Export',
    className: 'bg-blue-500/10 text-blue-400',
  },
  internal: {
    label: 'Internal',
    className: 'bg-purple-500/10 text-purple-400',
  },
};
